<template>
  <b-field
    :label="label"
    :message="alert.message"
    :type="alert.type"
    :class="{ 'obligatoire': obligatoire }">
    <b-select
      v-model="userId"
      :disabled="disabled"
      :placeholder="placeholder"
      expanded>
      <option v-if="!obligatoire" :value="null"></option>
      <option
        v-for="user in filteredUsers"
        :key="user.id"
        :value="user.id">
        {{getValue(user)}}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import getValueByPath from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'user-selected',
  props: {
    value: {
      type: Number,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    obligatoire: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    critere: {
      type: Function,
      default: () => true,
    },
    field: {
      type: String,
      default: 'decorator.nomPrenom',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    users() {
      return cloneDeep(this.parametre(PARAMETRES_KEYS.utilisateur))
        .sort((a, b) => this.getValue(a).localeCompare(this.getValue(b)));
    },
    filteredUsers() {
      return this.users
        .filter(u => u.actif || u.id === this.userId)
        .filter(u => this.critere(u));
    },
    userId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    alert() {
      const user = this.users.find(u => u.id === this.userId);
      if (!user) return { message: '', type: '' };
      return {
        message: !user.actif ? this.$t('utilisateur.warning.utilisateurArchive') : '',
        type: !user.actif ? 'is-warning' : '',
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getValue(obj) {
      return getValueByPath(obj, this.field);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
